// Copied from Kitt
// https://github.com/Typeform/kitt/blob/05d879218730c3562ab6a47329e5e12b4e2acd35/src/utils/get-element-by-text.ts
export var getElementByText = function getElementByText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var num = text.split('').reduce(function (acum, val) {
    return val.charCodeAt(0) + acum;
  }, 0);
  var selectionIndex = num % elements.length;
  return [elements[selectionIndex], selectionIndex];
};